import DOMPurify from 'dompurify'

// eslint-disable-next-line import/prefer-default-export
export function sanitize(source: string) {
  return DOMPurify.sanitize(source)
}
